import React from "react";
import { useDispatch } from "react-redux";
import { addItemToBasket } from "../features/basketSlice";
import "./Product.css";

function Product({ id, title, image, price, rating }) {
  const dispatch = useDispatch();

  const addToBasket = () => {
    dispatch(
      addItemToBasket({
        id: id,
        title: title,
        image: image,
        price: price,
        originalPrice: price,
        rating: rating,
        quantity: 1,
      })
    );
  };

  return (
    <div className="product">
      <div className="product__info">
        <div>{title}</div>
        <div className="product__price">
          <small>$</small>
          <strong>{price}</strong>
        </div>
        <div className="product__rating">
          {Array(rating)
            .fill()
            .map((_, i) => (
              <p key={i}>⭐</p>
            ))}
        </div>
      </div>
      <img className="product__img" src={image} alt="" />

      <button onClick={addToBasket}>Add To Cart</button>
    </div>
  );
}

export default Product;
